import React from 'react';
import { LogoFilters } from './components/LogoFilters';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { About } from './components/About';
import { Services } from './components/Services';
import { Fleet } from './components/Fleet';
import { Drivers } from './components/Drivers';
import { Coverage } from './components/Coverage';
import { WhyHoldFast } from './components/WhyHoldFast';
import { CtaBanner } from './components/CtaBanner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-white" data-id="element-0" data-mp="31ctflscv2296">
      <LogoFilters data-id="element-1" data-mp="2wjgpfdsj9neb" />
      <Header data-id="element-2" data-mp="2wiyvwox99na3" />
      <main data-id="element-3" data-mp="2wifgbev2vaz8">
        <Hero data-id="element-4" data-mp="2wip2ssgwz006" />
        <StatsBar data-id="element-5" data-mp="2wi5mfg6wwjo9" />
        <About data-id="element-6" data-mp="28u5z6q8t7bef" />
        <Services data-id="element-7" data-mp="28tmdqzjya4vn" />
        <Fleet data-id="element-8" data-mp="28t4ju9krg2qw" />
        <Drivers data-id="element-9" data-mp="28sl4n0mhvsgk" />
        <Coverage data-id="element-10" data-mp="28s2zfehuu3wi" />
        <WhyHoldFast data-id="element-11" data-mp="23vkuoemiy5k6" />
        <CtaBanner data-id="element-12" data-mp="23w4c7u89irxo" />
        <Contact data-id="element-13" data-mp="23utcq6luo6cd" />
      </main>
      <Footer data-id="element-14" data-mp="23ti7s3go4sjo" />
    </div>;
}